import type { ThinkingLevel } from "@lib/agentConsole";

export enum GenerativeAiAgentsModelsProviderCode {
  BRAZE = 0,
  OPENAI = 1,
  ANTHROPIC = 2,
  GOOGLE = 3,
  DATABRICKS_MOSAIC = 4,
}

export interface GenerativeAiAgentsModelsModel {
  name: string;
  model: string;
  /** Array of supported thinking levels for this model */
  supported_thinking_levels?: ThinkingLevel[];
  /** Human-readable upstream provider name for models aggregated from multiple providers (e.g. "OpenAI", "Anthropic"). Absent for first-class provider models. */
  sub_provider?: string;
}

export interface GenerativeAiAgentsModelsProvider {
  code: GenerativeAiAgentsModelsProviderCode;
  name: string;
  models: GenerativeAiAgentsModelsModel[];
}

export interface GenerativeAiAgentsModelsResult {
  results: GenerativeAiAgentsModelsProvider[];
}
